import { Subject } from 'rxjs';

export abstract class Closable {
  close(): void {}
  result = new Subject<any>();
  state: 'void' | '*' = '*';
}
